import { initSwiper } from '../components/swiper';
import initCartUpsellAtc from '../components/cart-upsell-atc';
import changeCart from './changeCart';
import getLocalePrefix from './getLocalePrefix';
import renderCartUpsellRecommendations from './renderCartUpsellRecommendations';
import { EVENTS } from '../utils/constants';

const renderMinicart = async () => {
  const minicartLineItemSelector = '[data-minicart-line-item]';

  const getMinicartData = async () => {
    const localePrefix = getLocalePrefix();
    const url = `${window.location.origin}${localePrefix}/cart?view=minicart`;
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      return await res.text();
    } catch (e) {
      console.error('Failed to fetch minicart:', e);
      return null;
    }
  };

  const reinitMinicartUpsell = () => {
    if (!window.theme.swiperObjects) window.theme.swiperObjects = [];

    const sliderEl = document.querySelector('[data-minicart-upsell-swiper]');
    if (!sliderEl) return;

    const existingSwiperIndex = window.theme.swiperObjects.findIndex(swiper => swiper?.el === sliderEl);

    if (existingSwiperIndex !== -1) {
      const existingSwiper = window.theme.swiperObjects[existingSwiperIndex];
      if (existingSwiper && !existingSwiper.destroyed) {
        existingSwiper.destroy(true, true);
      }
      window.theme.swiperObjects.splice(existingSwiperIndex, 1);
    }

    const newSwiper = initSwiper(sliderEl);
    window.theme.swiperObjects.push(newSwiper);
  };

  const setLineItemLoadingState = (el) => {
    el?.classList.add('opacity-50', 'pointer-events-none');
  };

  const bindMinicartEvents = (renderMinicartFn) => {
    const minicart = document.querySelector('[data-minicart]');
    if (!minicart) return;

    if (minicart.dataset.eventsBound === 'true') return;
    minicart.dataset.eventsBound = 'true';

    minicart.addEventListener('click', async (evt) => {
      const removeBtn = evt.target.closest('[data-minicart-remove-item]');
      const minusBtn = evt.target.closest('[data-minicart-qty-minus]');
      const plusBtn = evt.target.closest('[data-minicart-qty-plus]');
      const actionBtn = removeBtn || minusBtn || plusBtn;
      if (!actionBtn || actionBtn.disabled) return;
      evt.preventDefault();

      const lineItem = actionBtn.closest(minicartLineItemSelector);
      const quantityEl = lineItem?.querySelector('[data-line-item-quantity]');
      const currentQty = Number(quantityEl?.dataset.lineItemQuantity);

      let newQty = null;
      if (removeBtn) {
        newQty = 0;
      } else if (minusBtn && currentQty > 1) {
        newQty = currentQty - 1;
      } else if (plusBtn && currentQty > 0) {
        newQty = currentQty + 1;
      }
      if (newQty === null) return;

      const lineItemKey = removeBtn?.dataset.minicartRemoveItem
        || minusBtn?.dataset.minicartQtyMinus
        || plusBtn?.dataset.minicartQtyPlus;

      setLineItemLoadingState(lineItem);
      await changeCart(lineItemKey, newQty);
      await renderMinicartFn();
    });
  };

  const minicartContent = document.querySelector('[data-minicart-content]');
  if (!minicartContent) return;

  const htmlText = await getMinicartData();
  if (!htmlText) return;

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlText, 'text/html');
  const minicartNewData = doc.querySelector('[data-minicart-render]');
  if (!minicartNewData) return;
  minicartContent.innerHTML = minicartNewData.innerHTML;

  reinitMinicartUpsell();
  initCartUpsellAtc(renderMinicart);
  await renderCartUpsellRecommendations(renderMinicart);
  bindMinicartEvents(renderMinicart);
  // The drawer body is replaced wholesale on every render, so anything a third
  // party injected into it is gone — this is their cue to re-inject.
  document.dispatchEvent(new CustomEvent(EVENTS.MINICART_RENDERED, { detail: { minicartEl: minicartContent } }));
};

export default renderMinicart;
